import { render, staticRenderFns } from "./MovieDetail.vue?vue&type=template&id=14b00ece&scoped=true"
import script from "./MovieDetail.vue?vue&type=script&lang=js"
export * from "./MovieDetail.vue?vue&type=script&lang=js"
import style0 from "./MovieDetail.vue?vue&type=style&index=0&id=14b00ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b00ece",
  null
  
)

export default component.exports